import { Link } from 'react-router-dom';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import time from 'utils/time';
import GeneralItemActions from 'components/Dashboard/ItemController/GeneralItemActions';
import { CrmContactImage } from 'components/Dashboard/Influence/CrmContacts/CrmContactsTable/CrmContactItem/CrmContactItem';

const InteractionCard = ({ item }) => {
  const {
    id,
    title,
    interactionType,
    dateTime,
    addedByUserFullName,
    description,
    firstCrmContactName,
    firstCrmContactImageUrl,
    crmContactIds,
    recipientsCount,
  } = item;
  const isEmailType = /email/i.test(interactionType);
  const showStakeholder = !isEmailType && !!firstCrmContactName;
  const extraStakeholders = isEmailType ? 0 : (crmContactIds?.length ?? 0) - 1;

  return (
    <li className='my-2'>
      <Link to={`/people/interactions/${id}`} className='d-block px-4 py-3 text-decoration-none'>
        <div className='d-flex justify-content-between align-items-center mb-2'>
          <p className='mb-0 paragraph-p1 text-light-blue-100'>{addedByUserFullName}</p>
          <div className='d-flex align-items-center'>
            <span className='rounded-pill border bg-light-blue-5 paragraph-p1 specific-x-padding-13 specific-y-padding-2 light-60-text mr-3'>
              {interactionType}
              {recipientsCount > 0 && (
                <>
                  <span className='dot d-inline-block-centered'></span>
                  <span>{`${recipientsCount} recipient${recipientsCount > 1 ? 's' : ''}`}</span>
                </>
              )}
            </span>
            <p className='mb-0 paragraph-p1 main-light-text flex-shrink-0'>
              {/T00:00:00$/.test(dateTime)
                ? time(dateTime).format('DD MMM[,] YYYY')
                : time(dateTime).formatEmbargoedDate()}
            </p>
            <div className='ml-2 d-flex align-items-center'>
              <GeneralItemActions item={item} influenceItem={true} itemActionsProps={{ noDots: true }} />
            </div>
          </div>
        </div>
        {showStakeholder && (
          <div className='d-flex align-items-center mb-2'>
            <div className='mr-2 flex-shrink-0'>
              <CrmContactImage imageUrl={firstCrmContactImageUrl} size={25} />
            </div>
            <p className='mb-0 font-weight-bold main-dark-text paragraph-p1'>
              {firstCrmContactName}
              {extraStakeholders > 0 && (
                <span className='font-weight-normal main-light-text ml-1'>{` +${extraStakeholders} others`}</span>
              )}
            </p>
          </div>
        )}
        {title && <p className='mb-1 font-weight-bold main-dark-text paragraph-p1'>{title}</p>}
        {description && (
          <div
            className='mb-0 editor-content-preview border-left-2 border-main-blue pl-3 mt-1 line-clamp-1'
            style={{ height: '21px' }}
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}
      </Link>
    </li>
  );
};

const InteractionCardSkeleton = () => (
  <li className='my-2'>
    <div className='d-block px-4 py-3'>
      <div className='d-flex justify-content-between align-items-center mb-2'>
        <Skeleton height={14} width={120} />
        <div className='d-flex align-items-center'>
          <Skeleton height={24} width={80} borderRadius={50} className='mr-3' />
          <Skeleton height={14} width={100} />
        </div>
      </div>
      <Skeleton height={16} width={260} className='mb-1' />
      <Skeleton height={14} width={180} />
    </div>
  </li>
);

export const InteractionListSkeleton = () => (
  <SkeletonTheme baseColor='#f2f2f2'>
    <ul className='policy-list px-0 items-list'>
      {Array(6)
        .fill()
        .map((_, i) => (
          <InteractionCardSkeleton key={i} />
        ))}
    </ul>
  </SkeletonTheme>
);

export const InteractionScrollSkeleton = () => (
  <SkeletonTheme baseColor='#f2f2f2'>
    <InteractionCardSkeleton />
  </SkeletonTheme>
);

export default InteractionCard;
